module.exports = __webpack_public_path__ + "img/5_74.c9b4ee8c.png";